import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { productApi, Product } from '../services/api';
import './Footer.css';

const Footer: React.FC = () => {
  const [categories, setCategories] = useState<string[]>([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await productApi.getAll(true);
        const products: Product[] = response.data;
        
        // 提取所有唯一的分类
        const categorySet = new Set<string>();
        products.forEach(product => {
          if (product.category && product.category.trim()) {
            categorySet.add(product.category.trim());
          }
        });
        
        // 转换为数组并排序
        const categoryList = Array.from(categorySet).sort();
        setCategories(categoryList);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };
    fetchCategories();
  }, []);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>UPWORK Hotel Suppliers</h3>
          <p>Upwork Sdn. Bhd.</p>
          <p>Your trusted partner for hotel amenities in Malaysia</p>
        </div>
        
        <div className="footer-section">
          <h4>Quick Links</h4>
          <Link to="/">Home</Link>
          <Link to="/products">Products</Link>
          <Link to="/about">About Us</Link>
          <Link to="/news">News</Link>
          <Link to="/contact">Contact</Link>
        </div>
        
        <div className="footer-section">
          <h4>Product</h4>
          {categories.length > 0 ? (
            <div className="footer-products">
              {categories.map((category, index) => (
                <Link 
                  key={index} 
                  to={`/products?category=${encodeURIComponent(category)}`}
                  className="footer-product-link"
                >
                  {category}
                </Link>
              ))}
            </div>
          ) : (
            <p>Loading categories...</p>
          )}
        </div>
        
        <div className="footer-section">
          <h4>Contact Us</h4>
          <p>Address: No. 14, Jalan Utama 2/20, Taman Perindustrian Puchong Utama, 47100 Puchong, Selangor D.E.</p>
          <p>Phone: +6011-56633168</p>
          <p>Email: info@upwork.com.my</p>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Upwork Sdn. Bhd. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
